import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { IUserAuthenticationTokens } from "../types";

export interface IUserLoginRefreshTokenMutationParameters {
    refreshToken: string;
}

export type IUserLoginRefreshTokenMutationResult = IUserAuthenticationTokens;

export const userLoginRefreshTokenMutation: IApiMutationFunction<IUserLoginRefreshTokenMutationParameters> = ({
    refreshToken,
}) => {
    return {
        method: "POST",
        url: "/login/refresh_token",
        data: {
            refresh_token: refreshToken,
        },
    };
};

export const useUserLoginRefreshTokenMutation = createApiMutationHook<
    IUserLoginRefreshTokenMutationParameters,
    IUserLoginRefreshTokenMutationResult
>(userLoginRefreshTokenMutation);
